// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-SrI","productName":"Table_productName__O0TJz"};